import { render, staticRenderFns } from "./classroomReality.vue?vue&type=template&id=670404e0&scoped=true"
import script from "./classroomReality.vue?vue&type=script&lang=js"
export * from "./classroomReality.vue?vue&type=script&lang=js"
import style0 from "./classroomReality.vue?vue&type=style&index=0&id=670404e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670404e0",
  null
  
)

export default component.exports